import axios from 'axios';
import { setCommonInterceptors } from '@/api/common/commonInterceptors';    //api 호출시 로딩화면 광역 적용
import { setAuthInterceptors } from '@/api/common/interceptors';

function createInstance() {
    const instance =  axios.create({
        baseURL: process.env.VUE_APP_API_URL,
    });

    return setCommonInterceptors(instance);
}

function createInstanceWithAuth() {
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
    });

    setCommonInterceptors(instance);
    return setAuthInterceptors(instance);
}

function createMultiPartInstanceWithAuth() {
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: { "Content-Type": "multipart/form-data" },
    });

    setCommonInterceptors(instance);
    return setAuthInterceptors(instance);
}

function createBlobResponseInstanceWithAuth() {
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        responseType: "blob",
    });

    setCommonInterceptors(instance);
    return setAuthInterceptors(instance);
}

export const instance = createInstance();
export const instanceWithAuth = createInstanceWithAuth();
export const multipartInstanceWithAuth = createMultiPartInstanceWithAuth();
export const blobResponseInstanceWithAuth = createBlobResponseInstanceWithAuth();
